import VxeSwitchComponent from './src/switch';
import { dynamicApp } from '../dynamics';
export var VxeSwitch = Object.assign(VxeSwitchComponent, {
    install: function (app) {
        app.component(VxeSwitchComponent.name, VxeSwitchComponent);
    }
});
export var Switch = VxeSwitch;
dynamicApp.component(VxeSwitchComponent.name, VxeSwitchComponent);
export default VxeSwitch;
